import React from 'react';
import { SectionHeading } from '../SectionHeading';
interface MetroIntroProps {
  cityName: string;
  sportList: string;
  image: string;
  onCta: () => void;
}
const expectations = ['Age-appropriate instruction emphasizing sportsmanship and healthy competition.', 'Weekly sportsmanship lessons.', 'All skill levels welcome – No tryouts. No drafts.', 'Everyone plays – every game.', 'No fundraising.', 'One day per week – practice is conveniently scheduled prior to the game.', 'Trained officials at every game.', '“When in Doubt Sit Out” Concussion Safety Policy and education for parents and coaches.'];
export function MetroIntro({
  cityName,
  sportList,
  image,
  onCta
}: MetroIntroProps) {
  return <section aria-labelledby="metro-intro" className="px-5 py-12 md:px-10 md:py-14" data-id="element-102" data-mp="21xgj8cwuin4h">
      <SectionHeading id="metro-intro" className="mx-auto max-w-4xl" data-id="element-103" data-mp="2pnavas9cc7no">
        {sportList} youth sports leagues for kids ages 3 and up in {cityName}
      </SectionHeading>
      <div className="mt-10 grid gap-10 lg:grid-cols-2" data-id="element-104" data-mp="3h4zv7xvqycr2">
        <div className="text-sm leading-relaxed text-brand-ink" data-id="element-105" data-mp="3h5hqosal4mxx">
          <p data-id="element-106" data-mp="3c77tkc5avc9o">
            i9 Sports® offers fun, organized and educational youth sports leagues throughout the {cityName} area. Kids can choose from sports such as {sportList}.
          </p>
          <h3 className="mt-8 font-display text-[28px] font-bold uppercase leading-tight text-brand-navy" data-id="element-107" data-mp="3l6l47855u6vz">
            What to expect from i9 Sports® youth sports leagues in {cityName}:
          </h3>
          <p className="mt-2" data-id="element-108" data-mp="3uxfqgciep6hf">Whichever sport or sports you choose, parents, coaches and kids can expect:</p>
          <ul className="mt-3 list-disc space-y-1.5 pl-5 marker:text-brand-navy" data-id="element-109" data-mp="cq05ck68su6l">
            {expectations.map(e => <li key={e} data-id="element-110" data-mp="8qrb7e7aiuai">{e}</li>)}
          </ul>
          <p className="mt-4" data-id="element-111" data-mp="2eiejr99kvgi9">Sign up today to join the fun!</p>
          <button type="button" onClick={onCta} className="mt-6 rounded-sm bg-brand-red px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-brand-redDark" data-id="element-112" data-mp="2eiwlglf0emxk">
            Find A Program
          </button>
        </div>
        <img src={image} alt={`Kids playing youth sports in ${cityName}`} className="h-72 w-full object-cover lg:h-[420px]" data-id="element-113" data-mp="ifrwrdjaakr8" />
      </div>
    </section>;
}